(() => {
  const blockedParents = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'PRE', 'CODE']);
  const emDash = '\u2014';
  const cleanTextNode = (node) => {
    if (!node || !node.nodeValue || !node.nodeValue.includes(emDash)) return;
    if (node.parentElement && blockedParents.has(node.parentElement.tagName)) return;
    node.nodeValue = node.nodeValue.split(emDash).join('-');
  };
  const cleanTree = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) cleanTextNode(node);
  };
  const start = () => {
    cleanTree(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) cleanTree(node);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
